export default __webpack_public_path__ + "static/media/apari-logo-white.2f0c5dcd.svg";